import React from "react";
import "./sectionWrapper.css";

const SectionWrapper = props => {
  return <div className="navbar__section-wrapper">{props.children}</div>;
};

export default SectionWrapper;
